import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import { UUID } from 'angular2-uuid';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { ModalIdDocumentComponent } from 'src/app/components/dialogs/modal-id-document/modal-id-document.component';
import { ModelModalLinkOneButtonComponent } from 'src/app/components/dialogs/model-modal-link-one-button/model-modal-link-one-button.component';
import { LoadingService } from 'src/app/components/loading/loading-service.service';
import { AlertBarService } from '../alert-bar/alert-bar.service';
import { ApiService } from '../api/api.service';
import { ContractsService } from '../contracts/contracts.service';
import { GlobalService } from '../global/global.service';
import { UnicoSelfieCameraService } from '../selfie/unico.service';
import { SessionService } from '../session/session.service';
import { take, takeUntil } from 'rxjs/operators';
import {
  NgxImageCompressService,
  DataUrl,
  DOC_ORIENTATION,
} from 'ngx-image-compress';
import { environment } from 'src/environments/environment';

export interface DataResponseByUnico {
  Sucesso: boolean;
  Mensagem: string;
  Url: string;
}

@Injectable({
  providedIn: 'root',
})
export class FormalizationService implements OnDestroy {
  file: any;
  files: any = [];
  formData!: FormData;
  docs: any = {
    docVerse: { Conteudo: '' },
    docFront: { Conteudo: '' },
    holerite: { Conteudo: '' },
    extract: { Conteudo: '' },
    installment: { Conteudo: '' },
  };
  hasDocumentVerse = true;
  complete = false;
  Token: any;
  userData: any;
  hash: any;
  key: any;
  documentsKey!: object;
  HasSendDoc!: boolean;
  getID: any;
  userBankInfo: any;
  debitUrl: any;
  docsComplete = false;
  qrCodeLink!: string;
  evidence!: object;
  mobileSelfieMessage!: boolean;
  responseJson: any;
  formalization: any;
  selfieError!: boolean;
  selfieErrorMessage!: string;

  imgResultAfterResize: DataUrl = '';

  private destroy$ = new Subject<void>(); // Controla destruição de assinaturas

  constructor(
    public dialog: MatDialog,
    private gf: GlobalService,
    public api: ApiService,
    public session: SessionService,
    public contracts: ContractsService,
    private route: Router,
    public loader: LoadingService,
    public router: ActivatedRoute,
    public storage: LocalStorageService,
    private selfie: UnicoSelfieCameraService,
    public toast: AlertBarService,
    private imageCompress: NgxImageCompressService
  ) {
    this.userData = this.session.getUserData();
    this.Token = this.session.getToken();
    this.load();
    console.log('---------');
  }

  load() {
    console.log(this.docs);
    this.docs = {
      docVerse: { Conteudo: '' },
      docFront: { Conteudo: '' },
      holerite: { Conteudo: '' },
      extract: { Conteudo: '' },
      installment: { Conteudo: '' },
    };
  }

  async upload(el: any, container: any, info: any) {
    console.log(this.docs);
    const file = el.target.files[0];
    let fileName: any;
    let localUrl: any;
    fileName = file['name'];

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async (event: any) => {
      localUrl = event.target.result;

      if (file.type.startsWith('image/'))
        this.imgResultAfterResize = await this.resizeImage(localUrl);
      else this.imgResultAfterResize = localUrl;

      switch (container) {
        case 'docFront':
          info.Conteudo = this.imgResultAfterResize;
          this.docs.docFront = info;
          break;

        case 'docVerse':
          info.Conteudo = this.imgResultAfterResize;
          this.docs.docVerse = info;
          break;

        case 'holerite':
          info.Conteudo = this.imgResultAfterResize;
          this.docs.holerite = info;
          break;

        case 'extract':
          info.Conteudo = this.imgResultAfterResize;
          this.docs.extract = info;
          break;

        case 'installment':
          info.Conteudo = this.imgResultAfterResize;
          this.docs.installment = info;
          break;
      }

      if (
        (this.docs.docFront.Conteudo ||
          this.contracts.pendentIndentity == false) &&
        (this.docs.docVerse.Conteudo ||
          this.contracts.pendentIndentityVerse == false)
      ) {
        this.docsComplete = true;
      }

      if (
        (this.docs.docFront.Conteudo ||
          this.contracts.pendentIndentity == false) &&
        (this.docs.docVerse.Conteudo ||
          this.contracts.pendentIndentityVerse == false) &&
        (this.docs.holerite.Conteudo ||
          this.contracts.pendentPayCheck == false) &&
        (this.docs.extract.Conteudo ||
          this.contracts.pendentExtract == false) &&
        (this.docs.installment.Conteudo ||
          this.contracts.pendentInstallmentHistory == false)
      ) {
        this.complete = true;
      }
    };
  }

  async resizeImage(localUrl: string) {
    let imageResult = '';
    await this.imageCompress
      .compressFile(localUrl, DOC_ORIENTATION.Default, 80, 600, 600)
      .then((result: DataUrl) => {
        imageResult = result;
      });
    return imageResult;
  }

  getHash(proposal: any) {
    this.hash = window.btoa(
      `${proposal.CodigoProposta}#${proposal.Key}#${proposal.Tipo}`
    );
  }

  sendFiles(proposal: any) {
    this.loader.startLoading();

    let i = 0;
    Object.values(this.docs).some((x: any) => {
      x.Conteudo = x.Conteudo.toString().replace(/^data:[^;]*;base64,/g, '');

      const filesData = Object.assign(x, { Token: this.Token });

      if (x.Conteudo != '') {
        this.api
          .query(
            'proposta/vincular-documento',
            { requisicao: filesData },
            'post'
          )
          ?.subscribe((data: any) => {
            if (i == 4) {
              if (!data.Mensagem) {
                console.log('mensagem de erro');
              }
            }

            i++;
          });
      }
    });

    if (this.contracts.steps.length == 1) {
      this.contracts.finalizarAtendimento();
    } else {
      this.route.navigateByUrl(
        'formalizacao/' +
        this.contracts.activeProposal.proposalCode +
        '/' +
        this.contracts.steps[1]
      );
      this.contracts.steps.splice(0, 1);
    }
  }

  declareAddress(data: any) {
    this.loader.startLoading();

    if (!!this.contracts.proposal && !this.contracts.activeProposal.length) {
      this.contracts.setActiveProposal(this.contracts.proposal);
    }
    delete data.SiglaUF;
    delete data.acceptDeclaration;
    data.CodigoProposta = this.contracts.activeProposal.proposalCode;
    data = Object.assign(data, {
      requisicao: {
        Token: this.Token,
        Key: this.contracts.activeProposal.propostaKey,
      },
    });

    this.api
      .query(`adr/cliente/salvar/${this.userData.CPF}`, data, 'post')
      ?.subscribe((data: any) => {
        this.loader.stopLoading();
        if (data.Sucesso) {
          this.storage.set('residencyDeclared', true);
          this.contracts.completeContract(
            this.contracts.activeProposal.proposalCode
          );

          if (this.contracts.steps.length == 1) {
            this.contracts.finalizarAtendimento();
          } else {
            this.route.navigateByUrl(
              'formalizacao/' +
              this.contracts.activeProposal.proposalCode +
              '/' +
              (this.contracts.steps.length
                ? this.contracts.steps[1]
                : 'contrato-documento')
            );
            this.contracts.steps.splice(0, 1);
            console.log(this.contracts);
          }
        }
      });
  }

  acceptContract() {
    this.load();
    this.storage.set('acceptedContract', true);
    this.route.navigateByUrl(
      'formalizacao/' +
      this.contracts.activeProposal.proposalCode +
      '/' +
      (this.contracts.steps.length ? this.contracts.steps[1] : 'selfie')
    );
    this.contracts.steps.splice(0, 1);
  }

  private getCurrentPosition(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      window.navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  }

  async postAceiteByUnico(): Promise<DataResponseByUnico> {
    this.loader.startLoading();
    this.storage.set('acceptedContract', true);
    const position = await this.getCurrentPosition();

    this.evidence = {
      location: {
        accuracy: position.coords.accuracy,
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      },
      device: {
        cordova: 'unknown',
        model: 'unknown',
        platform: 'Browser',
        uuid: UUID.UUID(),
        version: environment.version,
        manufacturer: 'unknown',
        isVirtual: false,
        serial: 'unknown',
      },
      playerId: '',
    };

    this.contracts.setActiveProposal(this.contracts.proposal);


    const request$ = this.api.query(
      `proposta/provavida/byunico/iniciar`,
      {
        Token: this.Token,
        Key: this.contracts.activeProposal.propostaKey,
        origem: 'site_af',
        documentos: false,
        hash: this.contracts.activeProposal.hash,
        Evidence: this.evidence,
      },
      'post'
    ) as Observable<DataResponseByUnico> | undefined;

    if (!request$) {
      throw new Error('Nao foi possivel iniciar o fluxo de provacao de vida.');
    }

    var result = firstValueFrom(request$);
    this.contracts.finalizarAtendimentoNovo();
    
    return result
  }


  getStatusAuthorizedDebit() {
    const url = new URL(this.contracts.debitUrl);
    let paramState: any = '';
    if (url.searchParams.get('state')) {
      paramState = url.searchParams.get('state');
    }

    const params = {
      'requisicao.codProposta': this.contracts.activeProposal.proposalCode,
      'requisicao.state': paramState,
    };

    this.api
      .query(
        `debito-em-conta/confirmar-debito` + '?token=' + this.Token + '',
        { params },
        'get'
      )
      ?.subscribe((data: any) => {
        if (data.Sucesso) {
          if (data.Retorno.debitoAutorizado) {
            this.route.navigateByUrl(
              `formalizacao/${this.contracts.activeProposal.proposalCode}/debito-em-conta/debito-aprovado`
            );

            setTimeout(() => {
              if (this.contracts.steps.length == 1) {
                this.contracts.finalizarAtendimento();
              } else {
                this.route.navigateByUrl(
                  'formalizacao/' +
                  this.contracts.activeProposal.proposalCode +
                  '/' +
                  this.contracts.steps[1]
                );
                this.contracts.steps.splice(0, 1);
              }
            }, 5000);
          } else {
            setTimeout(() => {
              this.getStatusAuthorizedDebit();
            }, 5000);
          }
        }
      });
  }

  async compressImage(src: any, newX: any, newY: any) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = 'data:image/png;base64,' + src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        elem.width = newX;
        elem.height = newY;
        const ctx = elem.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0, newX, newY);
          const data = ctx.canvas.toDataURL();
          res(data);
        }
      };
      img.onerror = (error) => rej(error);
    });
  }

  async sendSelfie(desktop: boolean, type: string, ID: number, hash: string) {
    this.Token = this.storage.get('Token');

    try {
      if (type) {
        if (hash) {
          this.route.navigateByUrl(`/formalizacao/selfie/capturar/${hash}`);
        } else {
          this.route.navigateByUrl(
            `/formalizacao/${ID}/selfie/capturar/${type}`
          );
        }
      } else {
        await navigator.mediaDevices.getUserMedia({ video: true });
        this.loader.startLoading();
        this.selfie.startSelfieCamera();
      }
    } catch (err) {
      this.openCamera();
    }

    this.selfie.takePictureSuccess$
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe((p: any) => {
        window.navigator.geolocation.getCurrentPosition(async (position) => {
          this.evidence = {
            location: {
              accuracy: position.coords.accuracy,
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            },
            device: {
              cordova: 'unknown',
              model: 'unknown',
              platform: 'Browser',
              uuid: UUID.UUID(),
              version: environment.version,
              manufacturer: 'unknown',
              isVirtual: false,
              serial: 'unknown',
            },
            playerId: '',
          };

          // let resizedBase64;
          // await this.compressImage(p.base64, 480, 640).then(compressed => {
          //   resizedBase64 = compressed;
          // })

          if (
            !this.contracts.activeProposal ||
            !this.contracts.activeProposal.hash ||
            !this.contracts.activeProposal.propostaKey
          ) {
            this.contracts.setActiveProposal(this.contracts.proposal);
          }

          this.api
            .query(
              'proposta/provavida/aceite',
              {
                Foto: p.base64,
                Jwt: p.encrypted,
                Evidence: this.evidence,
                hash: this.contracts.activeProposal.hash,
                key: this.contracts.activeProposal.propostaKey,
                Token: this.Token,
                requisicao: { Token: this.Token },
              },
              'post'
            )
            ?.pipe(take(1))
            .subscribe((data: any) => {
              if (data.Sucesso) {
                if (!desktop) {
                  this.mobileSelfieMessage = true;
                  this.contracts.confirmSelfie();
                }

                if (this.contracts.steps.length <= 1)
                  return this.contracts.finalizarAtendimento();

                if (desktop) {
                  this.route.navigateByUrl(
                    'formalizacao/' +
                    this.contracts.activeProposal.proposalCode +
                    '/' +
                    this.contracts.steps[1]
                  );
                  this.contracts.steps.splice(0, 1);
                }

                this.loader.stopLoading();
              } else {
                if (data.Mensagem != 'O bundle informado é inválido.') {
                  this.openAlert(
                    'Falha ao enviar a selfie: ' + data.Mensagem || ''
                  );
                  this.loader.stopLoading();
                }
              }
            });
        });
      });

    this.selfie.takePictureError$.subscribe((p: any) => {
      this.openAlert('Falha ao iniciar a camera: ' + p.message || '');
      this.loader.stopLoading();
    });

    this.selfie.takePictureSupport$.subscribe((p: any) => {
      this.openAlert('Problema ao iniciar a camera: ' + p.message || '');
      this.loader.stopLoading();
    });
  }

  validaSelfie(image: any, type: string, desktop: boolean, hash: string) {
    this.Token = this.storage.get('Token');
    this.loader.startLoading();

    this.api
      .query(
        'selfie/validar',
        {
          type: type,
          image: image._imageAsDataUrl.replace('data:image/png;base64,', ''),
          hash: this.contracts.activeProposal.hash,
          key: this.contracts.activeProposal.propostaKey,
          requisicao: { Token: this.Token },
        },
        'post'
      )
      ?.subscribe((data: any) => {
        if (data.Sucesso) {
          if (type == 'sem-expressao') {
            if (!data.smiling) {
              if (!data.faces) {
                this.selfieError = true;
                this.selfieErrorMessage =
                  'Não foi possível validar sua selfie. Tente novamente.';
              } else {
                this.selfieError = false;
                this.selfieErrorMessage = '';
                this.storage.set('faceToken', data.faceToken);

                if (hash) {
                  this.route.navigateByUrl(
                    `formalizacao/selfie/${this.prepareRedirectHash(
                      hash,
                      'sorrindo'
                    )}`
                  );
                } else {
                  this.route.navigateByUrl(
                    `formalizacao/${this.contracts.activeProposal.proposalCode}/selfie/sorrindo`
                  );
                }
              }
              this.loader.stopLoading();
            } else {
              this.selfieError = true;
              this.selfieErrorMessage =
                'É necessário, nesta etapa, enviar uma selfie sem sorrir.';
              this.loader.startLoading();
            }
          } else {
            if (data.smiling) {
              this.loader.startLoading();

              this.api
                .query(
                  'selfie/comparar',
                  {
                    faceToken1: this.storage.get('faceToken'),
                    faceToken2: data.faceToken,
                    hash: this.contracts.activeProposal.hash,
                    key: this.contracts.activeProposal.propostaKey,
                    requisicao: { Token: this.Token },
                  },
                  'post'
                )
                ?.subscribe((data: any) => {
                  if (data.samePerson == 1) {
                    if (!desktop) {
                      this.route.navigate([
                        'formalizacao/selfie/mobile/confirmacao',
                      ]);
                      this.loader.stopLoading();
                    } else {
                      if (this.contracts.steps.length == 1) {
                        this.contracts.finalizarAtendimento();
                        this.loader.stopLoading();
                      } else {
                        this.route.navigateByUrl(
                          'formalizacao/' +
                          this.contracts.activeProposal.proposalCode +
                          '/' +
                          this.contracts.steps[1]
                        );
                        this.contracts.steps.splice(0, 1);
                        this.loader.stopLoading();
                      }
                    }
                  }
                });
            } else {
              if (!data.faces) {
                this.selfieError = true;
                this.selfieErrorMessage =
                  'Não foi possível validar sua selfie. Tente novamente.';
                this.loader.stopLoading();
              } else {
                this.selfieError = true;
                this.selfieErrorMessage =
                  'É necessário, nesta etapa, enviar uma selfie sorrindo.';
                this.loader.stopLoading();
              }
            }
          }
        } else {
          this.toast.openAlert(data.Mensagem, 'error');
          this.loader.stopLoading();
        }
      });
  }

  signature(signature: any) {
    this.loader.startLoading();

    window.navigator.geolocation.getCurrentPosition(async (position) => {
      this.evidence = {
        location: {
          accuracy: position.coords.accuracy,
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        },
        device: {
          cordova: 'unknown',
          model: 'unknown',
          platform: 'Browser',
          uuid: UUID.UUID(),
          version: environment.version,
          manufacturer: 'unknown',
          isVirtual: false,
          serial: 'unknown',
        },
        playerId: '',
      };

      const body = {
        requisicao: {
          Evidence: this.evidence,
          Signature: signature.replace('data:image/png;base64,', ''),
          hash: this.contracts.activeProposal.hash,
          key: this.contracts.activeProposal.propostaKey,
          Token: this.Token,
        },
      };

      this.api.query('proposta/assinar', body, 'post')?.subscribe(
        (data: any) => {
          this.loader.startLoading();

          if (data.Sucesso == 1) {
            if (data.Signed == 1) {
              if (this.contracts.steps.length == 1) {
                this.contracts.getProposalDetails(
                  this.contracts.list,
                  this.contracts.activeProposal.proposalCode
                );
                this.contracts.finalizarAtendimento();
              } else {
                this.route.navigateByUrl(
                  'formalizacao/' +
                  this.contracts.activeProposal.proposalCode +
                  '/' +
                  this.contracts.steps[1]
                );
                this.contracts.steps.splice(0, 1);
              }
            }
          }
        },
        (e) => {
          this.loader.stopLoading();
          this.toast.openAlert(
            'Houve um erro ao processar a solicitação!',
            'error'
          );
          this.gf.toTop();
        }
      );
    });
  }

  onClickViewDocument(file: any) {
    this.dialog.open(ModalIdDocumentComponent, {
      data: {
        icon: 'error_outline',
        textIcon: 'Atenção',
        img: file,
      },
    });
  }

  openCamera() {
    this.dialog.open(ModelModalLinkOneButtonComponent, {
      data: {
        icon: 'help_outline',
        textIcon: 'Algo deu errado',
        title: 'Por favor, permita o acesso à câmera',
        text: 'A captura de selfie é uma etapa de segurança essencial para darmos sequência ao empréstimo. Para prosseguir, o App Sabemi Digital precisa ter acesso à sua câmera.',
        textExtra:
          'No iOS, revise também as configurações de privacidade do sistema: Privacidade > Câmera > Chrome.',
        textLink: 'Revisar configurações de privacidade do iOS',
        linkOutAdress: 'https://support.apple.com/pt-br/HT203033',
        btnOneIcon: 'replay',
        textBtnOne: 'Tentar novamente',
      },
    });
  }

  openAlert(mensagem: string) {
    this.dialog.open(ModelModalLinkOneButtonComponent, {
      data: {
        icon: 'help_outline',
        textIcon: 'Algo deu errado',
        title: 'Ocorreu uma falha com a Selfie!',
        text: 'A captura de selfie é uma etapa de segurança essencial para darmos sequência ao empréstimo.',
        textExtra: mensagem,
        btnOneIcon: 'replay',
        textBtnOne: 'Tentar novamente',
      },
    });
  }

  debitLater(proposalID: string) {
    const params = {
      codProposta: this.contracts.activeProposal.proposalCode,
      status: 0,
    };

    this.api
      .query(
        `debito-em-conta/termos-aceite` + '?token=' + this.Token + '',
        params,
        'put'
      )
      ?.subscribe((data: any) => {
        this.storage.set('afterDebit', true);
        this.loader.stopLoading();
        this.route.navigateByUrl(
          'formalizacao/' +
          this.contracts.activeProposal.proposalCode +
          '/' +
          this.contracts.steps[1]
        );
      });
  }

  prepareRedirectHash(hash: string, expression: string) {
    const parameters = atob(hash).split('#');
    return btoa(
      `${parameters[0]}#${parameters[1]}#${parameters[2]}#${expression}`
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
